import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { loginReturnParams } from 'src/app/shared/utils/session-tabs';

/**
 * Clave para el flag de registro en progreso
 * Se usa para evitar que usuarios con sesión Cognito pero sin registro completo
 * accedan al dashboard
 */
const REGISTRATION_IN_PROGRESS_KEY = 'aguacate_registration_in_progress';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private cognitoService: CognitoService, private router: Router) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const registrationInProgress = sessionStorage.getItem(REGISTRATION_IN_PROGRESS_KEY);
    if (registrationInProgress) {
      return of(this.router.createUrlTree(['/auth/dinamic-signup']));
    }

    return from(this.cognitoService.getUser()).pipe(
      map((userInfo: any) => {
        if (!userInfo || !userInfo.attributes || !userInfo.attributes.email) {
          return this.loginTree(state.url);
        }

        const userGroup = userInfo.attributes['custom:user-group'];

        if (userGroup === 'aguacate_client' || userGroup === 'aguacate_operator') {
          return true;
        }

        if (userGroup === 'aguacate_retail_client' || userGroup === 'aguacate_retail_cashier') {
          return this.router.createUrlTree(['/retail/home']);
        }

        return this.loginTree(state.url);
      }),
      catchError(() => {
        return of(this.loginTree(state.url));
      })
    );
  }

  /** Login con la página pedida anotada, para volver a ella al entrar. */
  private loginTree(url: string): UrlTree {
    return this.router.createUrlTree(['/auth/login'], {
      queryParams: loginReturnParams(url),
    });
  }
}
